const registerUserDictEN = {
  referralUsername: "Referral username",
  nameOfUserRefferalCodeInvalid: "Invalid referral username.",
  doYouHave: "Do you have a referral?",
  iHaveReferral: "I have a referral",
  yes: "Yes",
  no: "No",
  voucher: "Voucher code",
  doYouHaveVoucher: "Do you have a voucher?",
  username: "Username",
  password: "Password",
  confirmPassword: "Confirm password",
  fullName: "Full name",
  firstName: "First name",
  surname: "Last name",
  documentNumber: "Document number",
  selectCurrency: "Select a currency",
  terms: "I agree to the terms and conditions.",
  marketingEmail: "Receive emails about updates and promotions?",
  recaptcha: "Reverify ReCaptcha",
  signUp: "Sign up",
  proceedToPayment: "Proceed to Payment",
  payWithExtracoin: "Pay with extracoin",
  coupon: "Registration coupon",
  iHaveInviteCoupon: "I have an invitation coupon",
  enterInviteCoupon: "Enter your invitation coupon code",
  inviteCouponRequired: "Please enter your invitation coupon code.",
  uploadDocPic: "Upload document photo",
  on: "on",
  salePromoterRefExplanation:
    "You can only register as a Promoter through an Manager referral link.",
  // toast,
  referralUserNotFound: "Referral user not found.",
  invalidCoupon: "Invalid credit coupon.",
  couponDoesNotBelong: "The coupon does not belong to this referral user",
  genericError: "An error occurred. Please try again.",
  passwordMin8: "Password must be at least 8 characters long.",
  pleaseReverify: "Please complete the ReCAPTCHA verification.",
  paymentCheckout: "Payment checkout",
  phoneConfirmation: "Phone confirmation",
  phoneConfirmCodeExplanationPt1: "We have sent a message via SMS to",
  phoneConfirmCodeExplanationPt2:
    "with your confirmation code, please insert the code below to finish your registration",
  phoneConfirmCode: "Confirm code",
  pleaseUploadDocPic: "Please upload a photo of your ID",
  shippingRules: "Warning: It is not yet possible to use the shipping quote!",
  shippingRulesExplanation:
    "Our shipping service is available only to users who ship from addresses in Italy!",
  iKnow: "I know",
  alreadyHaveAccount: "Already have an account?",
  emailCanBeSpam: "Check your spam folder, the email may be there.",
  doubts: "Doubts?",
  payNow: "Pay now",
  doLogin: "Log in",
  termsAndConditions: "Terms and conditions",
  createFreeAccount: "Create free account",
  youAreRegistering: "You are registering as",
  createAccount: "Create account",
  registrationSuccessActivateYourAccount:
    "Registration successful! Please check your email to activate your account.",
  loginAndContinuePurchase: "Log in and continue your purchase",
  customerRegisterTitle: "Start earning more with what you already buy.",
  customerRegisterDescription:
    "As an Extraconomy Customer, every purchase can return to you in the form of Extracredits, a complementary credit that you use as part of the payment within the platform.",
  customerRegisterSubtitle: "Receive Extracredits whenever you buy from Extraconomy partners.",
  registerRoleCustomer: "CUSTOMER",
  registerRoleStore: "STORE",
  registerRoleManager: "MANAGER",
  registerRoleManagerAssociation: "MANAGER ASSOCIATION",
  registerRolePartner: "PARTNER",
  registerRoleSeller: "SELLER",
  registerRolePromoter: "PROMOTER",
  managerRegisterTitle: "Expand your influence as a Manager.",
  managerRegisterDescription:
    "As a Manager, you build and lead a business network, connecting people and companies in a collaborative economy.",
  managerRegisterSubtitle: "Lead. Connect. Transform your region.",
  managerRegisterSubtitleAssociation:
    "You are registering as a Manager Association. Upload the association document to complete registration.",
  associationPdfLabel: "Association document (PDF)",
  associationPdfRequired: "Upload the association PDF document to continue.",
  associationPdfInvalidType: "The file must be a PDF.",
  associationPdfTooLarge: "The PDF file must be at most 10 MB.",
  removeFile: "Remove",
  storeRegisterTitle: "Bring your physical store to digital with Extraconomy.",
  storeRegisterDescription:
    "Store registration is free and sets your foundation to enable online sales with the Start Seller plan whenever you want.",
  storeRegisterSubtitle: "Create your Store account and upgrade to marketplace sales at your own pace.",
  promoterRegisterTitle1: "Be a Promoter.",
  promoterRegisterTitle2: "Connect, Grow, Transform.",
  promoterRegisterDescription:
    "At Extraconomy, every connection counts. Offer consulting, connect companies, generate opportunities and build a collaborative economy that values people and sustainable results.",
  promoterRegisterSubtitle: "Build impact. Generate value. Be part of the change.",
  partnerRegisterTitle: "Be a Partner. Share, Grow, Thrive.",
  partnerRegisterDescription:
    "Join the Extraconomy network dedicated to professionals. Create your digital showcase, promote your commercial services, and build valuable connections that turn networking into concrete opportunities and shared revenue.",
  partnerRegisterSubtitle: "Build your network. Grow your business. Be part of the change.",
  sellerRegisterTitle: "Launch your e-commerce on Extraconomy. Sell, Scale, Digitize.",
  sellerRegisterDescription:
    "Join the digital network designed for online sellers. Activate your e-commerce platform, manage your products with full autonomy, and grow your sales toward new markets with fair and competitive commissions.",
  sellerRegisterSubtitle: "Sell anywhere. Maximize your profits. Be part of the change.",
  registerSEODescription:
    "Register on Extraconomy to access your account, expand your network, and take advantage of exclusive business opportunities.",
  createYourAccount: "Create your account",
};

export default registerUserDictEN;
